import React, { useState } from 'react';
import ActivityLoader from '../Common/ActivityLoader';
import BsModal from '../Common/BsModal';
import { useTheme } from '../../DataStore/ThemeContext';
import Notification from '../Common/Notification';
import { useStudent } from '../../DataStore/StudentContext';
import ajaxStudent from '../../util/remote/ajaxStudent';

const AlertDeleteContact = () => {

    const [loading, setLoading] = useState(false);
    const {setNotify} = useTheme();
    const { deleteContact, setDeleteContact,  getStudentContacts, studentId} = useStudent();


    const handleClose = () => setDeleteContact({ show: false, contact: null });


   if (!deleteContact.contact) return null;
  
   

    const confirm = async()=>{
        setLoading(true);
        const server_response = await ajaxStudent.deleteContact(deleteContact.contact.id);
        setLoading(false);
        if(server_response.status === "OK"){
            getStudentContacts(studentId); // Refresh contacts
            setNotify(<Notification type='success' message={server_response.message}/>)
        }else{
            setNotify(<Notification type='danger' message={server_response.message}/>)

        }
        handleClose();
    }

    return (
        <BsModal
            show={deleteContact.show}
            onClose={handleClose}
            title="Delete Contact"
            footer={
                <>
                    {loading && <ActivityLoader />}
                    {!loading && <>
                    <button className="btn btn-secondary" onClick={handleClose}>
                        Cancel
                    </button>
                    <button className="btn btn-danger" onClick={confirm}>
                        Confirm Delete
                    </button>
                    </>}
                </>
            }
        >


            {deleteContact.contact && <div className="d-flex justify-content-center align-items-center flex-column">
                <i 
                className="fa fa-question-circle text-danger" 
                style={{ fontSize: "40px", lineHeight: "1", marginTop: "20px" }}
                ></i>
                <h5 className='mt-1 text-dark text-center' style={{fontSize: '17px'}}>Are you sure you want delete this contact <i>{deleteContact.contact.contact_name}</i> ?</h5>
           
            </div>}
          

        </BsModal>
    );
};

export default AlertDeleteContact;
